import React, { useState, useRef, useEffect } from 'react';
import Card from "react-bootstrap/Card";
import UserAvatar from "../users/UserAvatar";
import {JSON_HEADERS} from "../../constants/constants";
import {useForm} from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {newCommentPlaceholder, newCommentFormData, sanitizeRedactorContent} from "../../utils/postingHelpers";
// import Redactor
import '../../../../../vendor/assets/stylesheets/redactor.min.css'
import {Redactor} from "../../../../../vendor/assets/javascripts/redactor";

export default function CommentForm(props) {

    let {
        currentUser,
        token,
        parentId,
        parentType,
        avatarSize=30,
        type='Comment',
        appendContent='',
        redirectUrl='',
        toggleRegistration=()=>{},
        leadData={}
    } = props;

    // Also in props: onNewComment
    const cta = `Post my ${type.toLowerCase()}`;
    const [btnCta, setBtnCta] = useState(cta);
    const [displayFormBtns, setDisplayFormBtns] = useState('none');
    const [expandForm, setExpandForm] = useState(false);
    const [positionAvatar, setPositionAvatar] = useState('center');
    const { register, handleSubmit, setValue, clearErrors, reset, formState: { errors, isSubmitting }} = useForm();
    const cancelBtnRef = useRef();

    const userSignedIn = !!currentUser;
    const adminUser = currentUser?.admin;
    const formData = newCommentFormData(type);
    const nonLoggedInInputStyles = !userSignedIn ? { height: '55px', padding: '16px 18px'} : {};
    const [redactor, setRedactor] = useState(null);

    const onCommentCreate = async(data) => {
        setBtnCta('Saving...');
        redactor.editor.focus();

        await fetch(formData.url, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify(data)
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            redactor.editor.getElement().parent().removeClass('redactor-focus');
            cancelBtnRef.current.focus();
            onCommentReset();
            props.onNewComment(jsonResponse.item);
        });
    }

    const onCommentReset = () => {
        closeComment();
        setBtnCta(cta);
        reset();
        clearErrors('body');
        setValue('body', '');
        redactor.editor.getElement().html('');
    }

    const onExpandForm = () => {
        if(!expandForm) {
            setExpandForm(true);
            setDisplayFormBtns('block');
            setPositionAvatar('start');
        }
    }

    const closeComment = () => {
        setExpandForm(false);
        setDisplayFormBtns('none');
        setPositionAvatar('center');
    }

    useEffect(() => {
        if(userSignedIn) {
            let redactorEl = Redactor(`#body-${parentId}`, { toolbar: false, callbacks: {
                    blur: function(e) {
                        // set textarea value for react-hook-form
                        let html = sanitizeRedactorContent(this.source.getCode());
                        setValue('body', html);
                        if(e.target.id != `cancel_${parentId}` &&  e.target.id != `save_${parentId}`) closeComment();
                    },
                    click: function(e) {
                        if(userSignedIn) {
                            if(this.source.getCode() == '' && appendContent) {
                                this.source.setCode(appendContent);
                                this.editor.endFocus();
                            }
                            onExpandForm()
                        }
                    }}
            });
            redactorEl.editor.getElement().html(''); // Hack fix for enter bug
            setRedactor(redactorEl);
        }
    }, []);

    const renderSignInToggle = () => {
        if(!userSignedIn) {
            return (
                <a
                    className={'position-absolute w-100 h-100'}
                    onClick={() => toggleRegistration(leadData)}
                    style={{ zIndex: '1080' }}
                />
            )
        }
    }

    return (
        <div className={'position-relative'}>
            {renderSignInToggle()}
            <Card className={`comment-form-card mb-0 align-items-${positionAvatar}`}>
                <div className={'w-auto'}>
                    <UserAvatar user={currentUser} avatarSize={avatarSize} />
                </div>
                <Form
                    noValidate={true}
                    acceptCharset='UTF-8'
                    onSubmit={handleSubmit(onCommentCreate)}
                >
                    <input type='hidden' id='authenticity_token' key='authenticity_token' value={token} {...register('authenticity_token')} />
                    <input type='hidden' id={formData.parent_key} key={formData.parent_key} value={parentId} {...register(formData.parent_key)} />

                    <Form.Group>
                        <Form.Control
                            as={'textarea'}
                            id={`body-${parentId}`}
                            style={nonLoggedInInputStyles}
                            placeholder={newCommentPlaceholder(parentType)}
                            {...register("body", { required: 'This field is required' })} />
                    </Form.Group>


                    <div id={'expand-form'} className={`d-${displayFormBtns}`}>
                        <div className={'d-flex flex-wrap flex-sm-nowrap mt-3'}>
                            {errors.body && <Form.Text className="text-danger">{errors.body.message}</Form.Text>}
                            <Button variant="light" className={'me-0 me-sm-2 my-2 my-sm-0 ms-sm-auto'} onClick={() => onCommentReset()} id={`cancel_${parentId}`} ref={cancelBtnRef}>
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit" className={'btn-hover-cursor'} disabled={isSubmitting} id={`save_${parentId}`}>
                                {btnCta}
                            </Button>
                        </div>
                    </div>

                </Form>

            </Card>
        </div>
    )
}